define('components/asset-player/models/media-file',[
    'components/boilerplate/models/base',
    'components/asset-player/models/media-file-types'
], function (Base, MediaFileTypes) {
    "use strict";

    return Base.extend({
        "complexRelations": function () {
            return [
                {
                    "attr": "assetGuid",
                    "fn": function (string) {
                        return string && string.toLowerCase() || string;
                    }
                }
            ];
        },

        "defaults": function () {
            return {
                "assetGuid": null,
                "url": null,
                "typeId": null
            };
        }
    }, {
        "Type": MediaFileTypes.Type,
        "TypeExtensions": MediaFileTypes.TypeExtensions
    });
});

